<div class="business-navbar__loading-ring" [style.height.px]="size" [style.width.px]="size" [style.color]="color"><div></div><div></div><div></div><div></div></div>
